import { Asset } from '../assetUtils'

const coingeckoUrl = 'https://api.coingecko.com/api/v3/'

export interface IMarketData {
  marketCap: number
  marketCapChange: number
  price: number
  priceChange: number
  totalSupply: number
}

/**
 * Get the current market data from coingecko API
 */
export const getMarketData = async (asset: Asset, toCurrency = 'usd'): Promise<IMarketData> => {
  const url = `${coingeckoUrl}coins/markets?vs_currency=${toCurrency.toLowerCase()}&ids=${asset.toLowerCase()}&order=market_cap_desc&per_page=100&page=1&sparkline=false`
  const marketRequest = await fetch(url)
  if (marketRequest.status !== 200) {
    throw new Error('Coingecko market data unavailable')
  }
  const marketResponse = await marketRequest.json()
  const marketData = marketResponse[0]
  return {
    marketCap: marketData['market_cap'] as number,
    marketCapChange: marketData['market_cap_change_percentage_24h'] as number,
    price: marketData['current_price'] as number,
    priceChange: marketData['price_change_percentage_24h'] as number,
    totalSupply: marketData['total_supply'] as number,
  }
}
